// SplashScreen.js
import React from 'react';
import { makeStyles } from '@material-ui/styles';
import Loading from '../../../components/loading/item-loading/loading';

const useStyles = makeStyles(() => ({
	splashScreen: {
		position: 'fixed',
		top: 0,
		left: 0,
		width: '100%',
		height: '100%',
		color: 'white',
		backgroundColor: '#242a2e',
		display: 'flex',
		flexFlow: 'column',
		justifyContent: 'center',
		alignItems: 'center',
		zIndex: '9999999',
	},
	splashTile : {
		position: 'absolute',
		top: '40%',
		transform: 'translateY(-50%)',

	}
}));

const SplashScreen = () => {
	const classes = useStyles();
	return (
		<div className={classes.splashScreen}>
			<h3 className={classes.splashTile}>تماشای فیلم و سریال در <strong>ببین</strong></h3>
			<Loading/>
		</div>
	);
};

export default SplashScreen;
